export default function (method) {
    return `/services/${method.parent.fullName}/${method.name}`;
}
export function getRpcPathFromStrings(service, method) {
    return `/services/${service}/${method}`;
}
// Returns the absolute representation of the given URL by prepending the
// current protocol and host, if needed.
export function absolutize(url) {
    if (url[0] === '/') {
        const { protocol, host } = location;
        return `${protocol}//${host}${url}`;
    }
    else {
        return url;
    }
}
